module.exports = __webpack_public_path__ + "static/import2-min-e86b487bf101cb01acdb9ab5f3847c3f.png";